import React from 'react';

export const Close: React.FC<React.SVGProps<SVGSVGElement>> = () => {
    return (
            <svg id="close" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18">
              <path id="Vector_-_Kontur" data-name="Vector - Kontur" d="M14.74,18,9.027,11,3.368,18H.157L7.545,9.152,0,0H2.937L8.915,7.557,15.006,0H18L10.523,9.3,17.808,18Z" transform="translate(18 18) rotate(180)" fill="#fff"/>
            </svg>
    )
}